(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    function getCard(el) {
      return el.closest('[class*="card"], [class*="product-card"], li, .grid__item');
    }

    function playVideo(card) {
      var video = card.querySelector('.product-hover-video__player');
      var overlay = card.querySelector('.product-hover-video');
      if (!video || !overlay) return;

      // Trigger load if browser hasn't fetched it yet (preload="none")
      if (video.readyState === 0) {
        video.load();
      }

      overlay.style.opacity = '1';

      // Wait for enough data then play
      var playAttempt = function () {
        video.play().catch(function () {
          // Silently ignore autoplay policy blocks
        });
      };

      if (video.readyState >= 2) {
        playAttempt();
      } else {
        video.addEventListener('canplay', playAttempt, { once: true });
      }
    }

    function stopVideo(card) {
      var video = card.querySelector('.product-hover-video__player');
      var overlay = card.querySelector('.product-hover-video');
      if (!video || !overlay) return;

      overlay.style.opacity = '0';
      video.pause();
      video.currentTime = 0;
    }

    function attachListeners() {
      document.querySelectorAll('.product-hover-video').forEach(function (overlay) {
        var card = getCard(overlay);
        if (!card || card._hoverVideoBound) return;

        card._hoverVideoBound = true;

        card.addEventListener('mouseenter', function () { playVideo(card); });
        card.addEventListener('mouseleave', function () { stopVideo(card); });

        // Touch: tap toggles play/stop
        card.addEventListener('touchstart', function () {
          var video = card.querySelector('.product-hover-video__player');
          if (video && video.paused) {
            playVideo(card);
          } else {
            stopVideo(card);
          }
        }, { passive: true });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attachListeners);
    } else {
      attachListeners();
    }

    // Re-attach for dynamically injected cards (infinite scroll, etc.)
    new MutationObserver(attachListeners).observe(document.body, {
      childList: true,
      subtree: true
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
